import { render, staticRenderFns } from "./ImportantNotificationModal.vue?vue&type=template&id=146f8a68&scoped=true"
import script from "./ImportantNotificationModal.vue?vue&type=script&lang=js"
export * from "./ImportantNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f8a68",
  null
  
)

export default component.exports